function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-symbols");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-symbols",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,14 C9.5,16 13.1573452,22.0002345 7.5,25 C7.42508711,25.0240157 2.5,23 4.5,18.5 C4.5,18.9784457 5.15513768,19.9522569 5.60726421,20.5263917 C5.5,19 7.5,17 8,14 Z M19,4.5 L16.5,8 L20,8 L13,15.5 L15,9.5 L13,9.5 L15,4.5 L19,4.5 Z M15.4583333,20.4596269 L25.5416667,20.4596269 M17.9469434,16.1525613 L22.9886101,24.8849841 M22.971055,16.1829676 L17.9293883,24.9153904",
  id: "Combined-Shape"
})));

const SvgIco30Symbols = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Symbols, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-symbols.ab521f45.svg";
export { ForwardRef as ReactComponent };